import { Injectable } from '@angular/core';
import { CentralPermissions } from '@portal-core/permissions/enums/central-permissions.enum';
import { PermissionsService } from '@portal-core/permissions/services/permissions.service';
import { ProjectStatus } from '@portal-core/projects/enums/project-status.enum';
import { ProjectsService } from '@portal-core/projects/services/projects.service';
import { CreateEditFileError, EditCodeError, FileBothEditPermissionsError, ProjectLockedError } from '@portal-core/workspaces/constants/workspace-file-error-messages.constants';
import { WorkspaceEditorPermissionsError } from '@portal-core/workspaces/models/workspace-editor-permissions-error.model';
import { combineLatest, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkspacesService {
  constructor(private permissionsService: PermissionsService, private projectsService: ProjectsService) { }

  getAccessErrorMessages$(projectId: number): Observable<WorkspaceEditorPermissionsError> {
    if (projectId) {
      return combineLatest([
        this.permissionsService.currentUserHasPermission$(CentralPermissions.EditCode, projectId),
        this.permissionsService.currentUserHasPermission$(CentralPermissions.CreateEditFiles, projectId),
        this.projectsService.getItemById$(projectId).pipe(
          map(project => project && project.Status === ProjectStatus.Locked)
        )
      ]).pipe(map(
        ([editCode, createEditFiles, isProjectLocked]) => {
          if (editCode && createEditFiles && !isProjectLocked) {
            return null;
          } else {
            if (isProjectLocked) {
              return { contentEditorPermissionsError: ProjectLockedError, codeEditorPermissionsError: ProjectLockedError };
            } else {
              if (!createEditFiles) {
                if (!editCode) {
                  return { contentEditorPermissionsError: CreateEditFileError, codeEditorPermissionsError: FileBothEditPermissionsError };
                } else {
                  return { contentEditorPermissionsError: CreateEditFileError, codeEditorPermissionsError: CreateEditFileError };
                }
              } else if (!editCode) {
                return { contentEditorPermissionsError: null, codeEditorPermissionsError: EditCodeError };
              }
            }
          }
          return null;
        }
      ))
    } else {
      return of(null);
    }
  }
}
